import { ApiEndpointTags } from '../imago-mp.types';
import type { Addon, AddonApiItem } from './subscriptions-query';
import { transformAddon } from './subscriptions-query';

export type UpdateAddonInput = {
    id: string;
    subscriptionId: string;
    name: string;
    type: string;
    quantity: number;
    salesforceQuoteNumber: string;
    notes: string;
    startDate: string;
    finishDate: string;
};

type UpdateAddonResponse = {
    addon?: AddonApiItem;
};

export const updateAddonMutation = {
    query: ({ id, subscriptionId: _unused, ...fields }: UpdateAddonInput) => ({
        url: `/mp/1/addons/${id}`,
        method: 'put',
        body: { addon: { id, ...fields } },
    }),
    transformResponse: (
        response: UpdateAddonResponse,
        _meta: unknown,
        arg: UpdateAddonInput,
    ): Addon => {
        const addon = response?.addon ?? {};
        return transformAddon({ ...addon, id: addon.id ?? arg.id });
    },
    invalidatesTags: (_result: Addon | undefined, _error: unknown, arg: UpdateAddonInput) => [
        { type: ApiEndpointTags.Subscription, id: arg.subscriptionId },
    ],
};
